import { useRemoteAsset } from './useRemoteAsset'

export function useTeam () {
  const { getStorageAsset } = useRemoteAsset()

  const getIcon = (team) => team.icon ? getStorageAsset(team.icon) : getDefaultIcon()
  const getDefaultIcon = () => 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs='
  return {
    getIcon,
  }
}
